import { API_BASE_URL } from '@synergy/config';

import { SearchInteractionApi } from '../api/search-interaction-api';
import { SearchInteractionType } from '../models/search-origin';

const api = new SearchInteractionApi(API_BASE_URL);

/**
 * Reports that a search result was opened or ordered. Not a thunk on purpose: this
 * changes nothing in the store, and nothing in the shop waits for it.
 */
export const reportSearchInteraction = (
    searchEventId: number | null | undefined,
    type: SearchInteractionType,
    productId: number,
    position?: number
): void => {
    if (!searchEventId) {
        return;
    }

    void api.report(searchEventId, type, productId, position);
};
